import React, { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomView,
} from "../../../../../../components";
import "./index.scss";
import {
  ICityItem,
  ICompanyItem,
  IItem,
  IOnSearchUser,
  IProvinceItem,
  ISchoolItem,
} from "../../../../../../types/common.interface";
import {
  GATEWAY,
  PAY_TYPE,
  TRANSACTION_REASON,
  TRANSACTION_STATUS,
} from "../../../../../../values/dropdownItems";
import Context from "../../../../../../context";
import { ICreateAndUpdateSuperAgent } from "../../../../../../types/superAgent.interface";
import values from "../../../../../../values";
import { useQuery } from "react-query";
import api from "../../../../../../api";
import CustomDropDownSearch from "../../../../../../components/CustomDropDownSearch";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";

const Filter = () => {
  const { requestWithdrawal, setRequestWithdrawal } = useContext(
    Context.WithdrawalScreen
  );
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // !! ===========================================================================================================
  // !!                                            superAgent
  // !! -----------------------------------------------------------------------------------------------------------

  const [selectedSuperAgent, setSelectedSuperAgent] =
    useState<ICreateAndUpdateSuperAgent>();
  const [superAgentSearchedValue, setSuperAgentSearchedValue] =
    React.useState<IOnSearchUser>();

  const getAllSuperAgent = useQuery(
    [values.useQueryKeys.getAllSuperAgent, superAgentSearchedValue],
    () =>
      api.post.administrator.getAllSuperAgent({
        search: {
          base: superAgentSearchedValue?.base.value,
          value: superAgentSearchedValue?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const AllSuperAgentWithCompleteName = getAllSuperAgent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  // !! ===========================================================================================================
  // !!                                            parent
  // !! -----------------------------------------------------------------------------------------------------------
  const [selectedParent, setSelectedParent] =
    useState<ICreateAndUpdateSuperAgent>();

  const [ParentSearchedValue, setParentSearchedValue] =
    React.useState<IOnSearchUser>();

  const getAllParentAdmin = useQuery(
    [values.useQueryKeys.getAllParent, ParentSearchedValue],
    () =>
      api.post.administrator.getAllParent({
        search: {
          base: ParentSearchedValue?.base.value,
          value: ParentSearchedValue?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const getAllParentCommon = useQuery(
    [values.useQueryKeys.getAllParent, ParentSearchedValue],
    () =>
      api.post.common.findParent({
        search: {
          base: ParentSearchedValue?.base.value,
          value: ParentSearchedValue?.searchedValue,
        },
      }),
    { enabled: userType !== "ADMIN" }
  );

  const getAllParent =
    userType === "ADMIN" ? getAllParentAdmin : getAllParentCommon;

  const AllParentWithCompleteName = getAllParent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  // !! ===========================================================================================================
  // !!                                            school
  // !! -----------------------------------------------------------------------------------------------------------
  const [selectedSchool, setSelectedSchool] = useState<ISchoolItem>();

  const [schoolSearchedValue, setSchoolSearchedValue] =
    React.useState<IOnSearchUser>();

  const getAllSchool = useQuery(
    [values.useQueryKeys.getAllSchool, schoolSearchedValue?.searchedValue],
    () =>
      api.post.common.findSchoolPost({
        search: {
          base: schoolSearchedValue?.base?.value,
          value: schoolSearchedValue?.searchedValue,
        },
      })
  );
  // !! ===========================================================================================================
  // !!                                            company
  // !! -----------------------------------------------------------------------------------------------------------
  const [searchedValueCompany, setSearchedValueCompany] =
    React.useState<IOnSearchUser>();
  const [selectedCompany, setSelectedCompany] = useState<any>();

  const getAllCompanyAdmin = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.administrator.getAllCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const getAllCompanyCommon = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.superAgent.findCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      }),
    { enabled: userType !== "ADMIN" && userType !== "COMPANY" }
  );

  const getAllCompany =
    userType === "ADMIN" ? getAllCompanyAdmin : getAllCompanyCommon;

  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );

  // !! ===========================================================================================================
  // !!                                            driver
  // !! -----------------------------------------------------------------------------------------------------------
  const [searchedValueDriver, setSearchedValueDriver] =
    React.useState<IOnSearchUser>();
  const [selectedDriver, setSelectedDriver] = useState<any>();

  const getAllDriverAdmin = useQuery(
    [
      values.useQueryKeys.getAllDriver,
      selectedCompany?._id,
      searchedValueDriver?.searchedValue,
    ],
    () =>
      api.post.common.findDriver({
        companyId: selectedCompany?._id,
        search: {
          base: searchedValueDriver?.base.value,
          value: searchedValueDriver?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const getAllDriverCommon = useQuery(
    [
      values.useQueryKeys.getAllDriver,
      selectedCompany?._id,
      searchedValueDriver?.searchedValue,
    ],
    () =>
      api.post.superAgent.findDriver({
        search: {
          base: searchedValueDriver?.base.value,
          value: searchedValueDriver?.searchedValue,
        },
      }),
    { enabled: userType !== "ADMIN" }
  );

  const getAllDriver =
    userType === "ADMIN" ? getAllDriverAdmin : getAllDriverCommon;

  const AllDriverWithCompleteName = getAllDriver?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item?.firstName + " " + item?.lastName,
      };
    }
  );

  // !! ===========================================================================================================
  // !!                                            driver
  // !! -----------------------------------------------------------------------------------------------------------
  const [searchedValueStudent, setSearchedValueStudent] =
    useState<IOnSearchUser>();
  const [selectedStudent, setSelectedStudent] = useState<any>();

  const getAllStudent = useQuery(
    [values.useQueryKeys.getAllService, searchedValueStudent?.searchedValue],
    () =>
      api.post.common.findStudent({
        search: {
          base: searchedValueStudent?.base?.value?.split(".")[1],
          value: searchedValueStudent?.searchedValue,
        },
      })
  );

  const AllStudentWithCompleteName = getAllStudent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  // !! ===========================================================================================================
  // !!                                            province & city
  // !! -----------------------------------------------------------------------------------------------------------

  const [selectedCity, setSelectedCity] = useState<any>();
  const [selectedProvince, setSelectedProvince] = useState<any>();

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () =>
      api.get.common.getAllCity({
        provinceCode: selectedProvince?.ProvinceCode,
      })
  );

  const { t } = useTranslation();

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} min_width="30vw">
        {/* {userType === "ADMIN" && (
        <>
          <p className="filter-labels">آموزش پرورش:</p>
          <CustomDropdownSearch
            items={AllSuperAgentWithCompleteName}
            itemName="completeName"
            defaultItem={requestCompany?.filters?.superAgent}
            onSelectItem={(event: IProvinceItem) =>
              setRequestCompany({
                ...requestCompany,
                filters: {
                  ...requestCompany?.filters,
                  superAgent: event,
                },
              })
            }
            placeHolder="انتخاب آموزش پرورش"
          />
        </>
      )} */}

        <CustomView.Row>
          <CustomView.Column medium={6}>
            <p className="filter-labels">{t("transactionStatus")}:</p>
            <CustomDropdownSearch
              items={TRANSACTION_STATUS}
              itemName="name"
              defaultItem={TRANSACTION_STATUS?.find(
                (item) =>
                  item.value === requestWithdrawal?.filters?.transactionStatus
              )}
              onSelectItem={(event: any) =>
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    transactionStatus: event?.value,
                  },
                })
              }
              placeHolder={t("transactionStatus")}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <p className="filter-labels">{t("for")}:</p>
            <CustomDropdownSearch
              items={TRANSACTION_REASON}
              itemName="name"
              defaultItem={TRANSACTION_REASON?.find(
                (item) => item.value === requestWithdrawal?.filters?.reason
              )}
              onSelectItem={(event: any) =>
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    reason: event?.value,
                  },
                })
              }
              placeHolder={t("for")}
            />
          </CustomView.Column>{" "}
          <CustomView.Column medium={6}>
            <p className="filter-labels">{t("payType")}:</p>
            <CustomDropdownSearch
              items={PAY_TYPE}
              itemName="name"
              defaultItem={PAY_TYPE?.find(
                (item) => item.value === requestWithdrawal?.filters?.isDeposit
              )}
              onSelectItem={(event: any) =>
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    isDeposit: event?.value,
                  },
                })
              }
              placeHolder={t("payType")}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <p className="filter-labels">{t("paymentGateway")}:</p>
            <CustomDropdownSearch
              items={GATEWAY}
              itemName="name"
              defaultItem={GATEWAY?.find(
                (item) => item.value === requestWithdrawal?.filters?.getway
              )}
              onSelectItem={(event: any) =>
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    getway: event?.value,
                  },
                })
              }
              placeHolder={t("paymentGateway")}
            />
          </CustomView.Column>
          {userType === "ADMIN" && (
            <CustomView.Column medium={6}>
              <label className="form-label">{t("superAgent")}</label>
              <CustomDropdownMultiSearch
                isSearch
                items={AllSuperAgentWithCompleteName}
                itemName="completeName"
                defaultItem={selectedSuperAgent}
                onSelectItem={(event: ICreateAndUpdateSuperAgent) => {
                  setSelectedSuperAgent(event);
                  setRequestWithdrawal({
                    ...requestWithdrawal,
                    filters: {
                      ...requestWithdrawal?.filters,
                      superAgent: event?._id,
                    },
                  });
                }}
                placeHolder={t("selectEducation")}
                baseSearch={values.dropdownBaseSearch.SUPER_AGENT_BASE_SEARCH.map(
                  (item) => ({
                    ...item,
                    title: t(item.title),
                  })
                )}
                setSearchedValue={setSuperAgentSearchedValue}
                searchedValue={superAgentSearchedValue}
                isLoading={getAllSuperAgent.isLoading}
                selectedBaseSearch={superAgentSearchedValue?.base?.value}
              />
            </CustomView.Column>
          )}
          <CustomView.Column medium={6}>
            <label className="form-label">{t("parent")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.PARENT_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={AllParentWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedParent(event);
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    parent: event?._id,
                  },
                });
              }}
              defaultItem={selectedParent}
              searchedValue={ParentSearchedValue}
              setSearchedValue={setParentSearchedValue}
              placeHolder={t("selectParent")}
              isLoading={getAllParent.isLoading}
              selectedBaseSearch={ParentSearchedValue?.base?.value}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("school")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SCHOOL_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={getAllSchool?.data?.result}
              itemName="name"
              onSelectItem={(event: ISchoolItem) => {
                setSelectedSchool(event);
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    school: event?._id,
                  },
                });
              }}
              defaultItem={selectedSchool}
              searchedValue={schoolSearchedValue}
              setSearchedValue={setSchoolSearchedValue}
              placeHolder={t("selectSchool")}
              isLoading={getAllSchool.isLoading}
              selectedBaseSearch={schoolSearchedValue?.base?.value}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("student")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SERVICE_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={AllStudentWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: any) => {
                setSelectedStudent(event);
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal.filters,
                    student: event,
                  },
                });
              }}
              defaultItem={selectedStudent}
              searchedValue={searchedValueStudent}
              setSearchedValue={setSearchedValueStudent}
              placeHolder={t("selectStudent")}
              isLoading={getAllStudent.isLoading}
              selectedBaseSearch={searchedValueStudent?.base?.value}
            />
          </CustomView.Column>
          {userType !== "COMPANY" && (
            <CustomView.Column medium={6}>
              <label className="form-label">{t("company")}</label>
              <CustomDropdownMultiSearch
                isSearch
                baseSearch={values.dropdownBaseSearch.COMPANY_BASE_SEARCH.map(
                  (item) => ({
                    ...item,
                    title: t(item.title),
                  })
                )}
                items={companyInformationWithCompanyName}
                itemName="companyName"
                onSelectItem={(event: ICompanyItem) => {
                  setSelectedCompany(event);
                  setRequestWithdrawal({
                    ...requestWithdrawal,
                    filters: {
                      ...requestWithdrawal?.filters,
                      company: event?._id,
                    },
                  });
                }}
                defaultItem={selectedCompany}
                searchedValue={searchedValueCompany}
                setSearchedValue={setSearchedValueCompany}
                placeHolder={t("selectCompany")}
                isLoading={getAllCompany.isLoading}
                selectedBaseSearch={
                  searchedValueCompany?.base?.value === "nationalCode"
                    ? "companyInformation.nationalCode"
                    : searchedValueCompany?.base?.value
                }
              />
            </CustomView.Column>
          )}
          <CustomView.Column medium={6}>
            <label className="form-label">{t("driver")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.DRIVER_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={AllDriverWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedDriver(event);
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    driver: event?._id,
                  },
                });
              }}
              defaultItem={selectedDriver}
              searchedValue={searchedValueDriver}
              setSearchedValue={setSearchedValueDriver}
              placeHolder={t("selectDriver")}
              isLoading={getAllDriver.isLoading}
              selectedBaseSearch={searchedValueDriver?.base?.value}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("province")}</label>
            <CustomDropDownSearch
              isSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              onSelectItem={(event: IProvinceItem) => {
                setSelectedProvince(event);
                setSelectedCity(undefined);
              }}
              placeHolder={t("selectProvince")}
              defaultItem={selectedProvince}
              isLoading={getAllProvince.isLoading}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("city")}</label>
            <CustomDropDownSearch
              isSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              onSelectItem={(event: ICityItem) => {
                setSelectedCity(event);
                setRequestWithdrawal({
                  ...requestWithdrawal,
                  filters: {
                    ...requestWithdrawal?.filters,
                    city: event?._id,
                  },
                });
              }}
              placeHolder={t("selectCity")}
              defaultItem={selectedCity}
              isLoading={getAllCity.isLoading}
            />
          </CustomView.Column>
        </CustomView.Row>

        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestWithdrawal({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

export default Filter;
